import __var_0__ from '@stdlib/random/base/arcsine';
import __var_1__ from '@stdlib/random/base/bernoulli';
import __var_2__ from '@stdlib/random/base/beta';
import __var_3__ from '@stdlib/random/base/betaprime';
import __var_4__ from '@stdlib/random/base/binomial';
import __var_5__ from '@stdlib/random/base/box-muller';
import __var_6__ from '@stdlib/random/base/cauchy';
import __var_7__ from '@stdlib/random/base/chi';
import __var_8__ from '@stdlib/random/base/chisquare';
import __var_9__ from '@stdlib/random/base/cosine';
import __var_10__ from '@stdlib/random/base/discrete-uniform';
import __var_11__ from '@stdlib/random/base/erlang';
import __var_12__ from '@stdlib/random/base/exponential';
import __var_13__ from '@stdlib/random/base/f';
import __var_14__ from '@stdlib/random/base/frechet';
import __var_15__ from '@stdlib/random/base/gamma';
import __var_16__ from '@stdlib/random/base/geometric';
import __var_17__ from '@stdlib/random/base/gumbel';
import __var_18__ from '@stdlib/random/base/hypergeometric';
import __var_19__ from '@stdlib/random/base/improved-ziggurat';
import __var_20__ from '@stdlib/random/base/invgamma';
import __var_21__ from '@stdlib/random/base/kumaraswamy';
import __var_22__ from '@stdlib/random/base/laplace';
import __var_23__ from '@stdlib/random/base/levy';
import __var_24__ from '@stdlib/random/base/logistic';
import __var_25__ from '@stdlib/random/base/lognormal';
import __var_26__ from '@stdlib/random/base/minstd';
import __var_27__ from '@stdlib/random/base/minstd-shuffle';
import __var_28__ from '@stdlib/random/base/mt19937';
import __var_29__ from '@stdlib/random/base/negative-binomial';
import __var_30__ from '@stdlib/random/base/normal';
import __var_31__ from '@stdlib/random/base/pareto-type1';
import __var_32__ from '@stdlib/random/base/poisson';
import __var_33__ from '@stdlib/random/base/randi';
import __var_34__ from '@stdlib/random/base/randn';
import __var_35__ from '@stdlib/random/base/randu';
import __var_36__ from '@stdlib/random/base/rayleigh';
import __var_37__ from '@stdlib/random/base/t';
import __var_38__ from '@stdlib/random/base/triangular';
import __var_39__ from '@stdlib/random/base/uniform';
import __var_40__ from '@stdlib/random/base/weibull';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

// This file is generated using `scripts/build.js`.

'use strict';

// MODULES //
var prng0 = __var_0__;
var prng1 = __var_1__;
var prng2 = __var_2__;
var prng3 = __var_3__;
var prng4 = __var_4__;
var prng5 = __var_5__;
var prng6 = __var_6__;
var prng7 = __var_7__;
var prng8 = __var_8__;
var prng9 = __var_9__;
var prng10 = __var_10__;
var prng11 = __var_11__;
var prng12 = __var_12__;
var prng13 = __var_13__;
var prng14 = __var_14__;
var prng15 = __var_15__;
var prng16 = __var_16__;
var prng17 = __var_17__;
var prng18 = __var_18__;
var prng19 = __var_19__;
var prng20 = __var_20__;
var prng21 = __var_21__;
var prng22 = __var_22__;
var prng23 = __var_23__;
var prng24 = __var_24__;
var prng25 = __var_25__;
var prng26 = __var_26__;
var prng27 = __var_27__;
var prng28 = __var_28__;
var prng29 = __var_29__;
var prng30 = __var_30__;
var prng31 = __var_31__;
var prng32 = __var_32__;
var prng33 = __var_33__;
var prng34 = __var_34__;
var prng35 = __var_35__;
var prng36 = __var_36__;
var prng37 = __var_37__;
var prng38 = __var_38__;
var prng39 = __var_39__;
var prng40 = __var_40__;


// MAIN //

var prngs = {};
prngs[ 'arcsine' ] = prng0.factory;
prngs[ 'bernoulli' ] = prng1.factory;
prngs[ 'beta' ] = prng2.factory;
prngs[ 'betaprime' ] = prng3.factory;
prngs[ 'binomial' ] = prng4.factory;
prngs[ 'box-muller' ] = prng5.factory;
prngs[ 'cauchy' ] = prng6.factory;
prngs[ 'chi' ] = prng7.factory;
prngs[ 'chisquare' ] = prng8.factory;
prngs[ 'cosine' ] = prng9.factory;
prngs[ 'discrete-uniform' ] = prng10.factory;
prngs[ 'erlang' ] = prng11.factory;
prngs[ 'exponential' ] = prng12.factory;
prngs[ 'f' ] = prng13.factory;
prngs[ 'frechet' ] = prng14.factory;
prngs[ 'gamma' ] = prng15.factory;
prngs[ 'geometric' ] = prng16.factory;
prngs[ 'gumbel' ] = prng17.factory;
prngs[ 'hypergeometric' ] = prng18.factory;
prngs[ 'improved-ziggurat' ] = prng19.factory;
prngs[ 'invgamma' ] = prng20.factory;
prngs[ 'kumaraswamy' ] = prng21.factory;
prngs[ 'laplace' ] = prng22.factory;
prngs[ 'levy' ] = prng23.factory;
prngs[ 'logistic' ] = prng24.factory;
prngs[ 'lognormal' ] = prng25.factory;
prngs[ 'minstd' ] = prng26.factory;
prngs[ 'minstd-shuffle' ] = prng27.factory;
prngs[ 'mt19937' ] = prng28.factory;
prngs[ 'negative-binomial' ] = prng29.factory;
prngs[ 'normal' ] = prng30.factory;
prngs[ 'pareto-type1' ] = prng31.factory;
prngs[ 'poisson' ] = prng32.factory;
prngs[ 'randi' ] = prng33.factory;
prngs[ 'randn' ] = prng34.factory;
prngs[ 'randu' ] = prng35.factory;
prngs[ 'rayleigh' ] = prng36.factory;
prngs[ 't' ] = prng37.factory;
prngs[ 'triangular' ] = prng38.factory;
prngs[ 'uniform' ] = prng39.factory;
prngs[ 'weibull' ] = prng40.factory;


// EXPORTS //
export default prngs;
